export default "__VITE_ASSET__CpFm7sk7__"